import { createTableColumns } from '@cf/ui-lib/utils';
import { renderComponent } from '@tanstack/svelte-table';
import BrandImage from '../../../routes/uilib/sellers/seller-details/column/brandImage.svelte';
import PlainText from '../plain-text.svelte';
import MarkertPlace from '../../../routes/uilib/sellers/seller-details/column/MarkertPlace.svelte';
import SellerBrandStatus from '../../../routes/uilib/sellers/seller-new/column/SellerBrandStatus.svelte';
import type { BrandStatusEnum } from '@cf/ui-lib';
import { Default } from '@cf/ui-lib/icons';

interface SellerBrandColumnsCallback {
	onSellerBrandStatus: (status: string, id: string) => void;
}

export const createSellerBrandColumns = (callbacks: SellerBrandColumnsCallback) => {
	return createTableColumns<any>([
		[
			'imgUrl',
			'Image',
			(info) =>
				renderComponent(BrandImage, {
					url: info.getValue() ? info.getValue() : Default,
					id: info.row.original.id
				}),
			undefined
		],
		['name', 'Name', (info) => renderComponent(PlainText, { data: info.getValue() }), undefined],
		[
			'status',
			'Status',
			(info) => {
				return renderComponent(SellerBrandStatus, {
					status: info.getValue() as BrandStatusEnum,
					id: info.row.original.id,
					onStatusChange: callbacks.onSellerBrandStatus
				});
			}
		],
		[
			'licensor',
			'Licensor',
			(info) => renderComponent(PlainText, { data: info.getValue() }),
			undefined
		],
		[
			'nicknames',
			'Nicknames',
			(info) => renderComponent(PlainText, { data: info.getValue() }),
			undefined
		],
		[
			'marketplaces',
			'Marketplaces',
			(info) => renderComponent(MarkertPlace, { data: info.getValue() }),
			undefined
		]
	]);
};
